import React from 'react'
import Call from '../Img/call.png'
import Email from '../Img/emailicon.png'
import Comment from '../Img/comment.png'
import './ContactUsComponent.css'

const ContactUsComponent = () => {
    return(
        <div className="contact-page">
            <div className='container admin-container'>
                <div className="row mt-5">
                    <div className="col-md-12 col-sm-12">
                        <div className="contact-header d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h3 className="mb-1">
                                    <i className="fa fa-phone text-warning me-2"></i>
                                    Contact Us
                                </h3>
                                <p className="text-muted">We're here to help you with all your badminton needs</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Contact Cards Section */}
                <div className="row mb-5">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h4 className="mb-0">
                                <i className="fa fa-info-circle text-primary me-2"></i>
                                Get In Touch
                            </h4>
                        </div>
                        
                        <div className="row g-4">
                            {/* Phone Card */}
                            <div className="col-md-4">
                                <div className="contact-card">
                                    <div className="contact-card-icon">
                                        <i className="fa fa-phone fa-2x text-primary"></i>
                                    </div>
                                    <div className="contact-card-content">
                                        <h5 className="contact-card-title">Call Us</h5>
                                        <p className="contact-card-text">0498623111</p>
                                        <small className="text-muted">
                                        Mon- Friday 5pm - 10pm<br/>
                                        Sat 9am - 1pm<br/>
                                        Sun 2pm - 9pm
                                        </small>
                                    </div>
                                </div>
                            </div>

                            {/* Email Card */}
                            <div className="col-md-4">
                                <div className="contact-card">
                                    <div className="contact-card-icon">
                                        <i className="fa fa-envelope fa-2x text-success"></i>
                                    </div>
                                    <div className="contact-card-content">
                                        <h5 className="contact-card-title">Email Us</h5>
                                        <p className="contact-card-text">
                                            admin@playbadminton.com.au<br />
                                            info@playbadminton.com.au
                                        </p>
                                        <small className="text-muted">We'll respond within 24 hours</small>
                                    </div>
                                </div>
                            </div>

                            {/* Address Card */}
                            <div className="col-md-4">
                                <div className="contact-card">
                                    <div className="contact-card-icon">
                                        <i className="fa fa-map-marker fa-2x text-danger"></i>
                                    </div>
                                    <div className="contact-card-content">
                                        <h5 className="contact-card-title">Visit Us</h5>
                                        <p className="contact-card-text">
                                            Maribyrnong College<br />
                                            River Street, Maribyrnong<br />
                                            Victoria, 3032, Australia
                                        </p>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Map Section */}
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h4 className="mb-0">
                                <i className="fa fa-map text-warning me-2"></i>
                                Find Our Location
                            </h4>
                        </div>
                        
                        <div className="map-container">
                            <div className="map-wrapper">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1576.7559659518854!2d144.88826648901352!3d-37.77804082300423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65dcf55b211d5%3A0xd9960fe959b78da9!2s2%20River%20St%2C%20Maribyrnong%20VIC%203032%2C%20Australia!5e0!3m2!1sen!2sin!4v1706628171255!5m2!1sen!2sin"
                                    className="map-iframe"
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Badminton Club Location"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactUsComponent;
